// ISO 3166-1 alpha-3 countries
export const COUNTRY_CODES = {
    "AFG": { name: "Afghanistan", coordinates: [69.1761, 34.5228] },
    "ALB": { name: "Albania", coordinates: [19.8172, 41.3317] },
    "DZA": { name: "Algeria", coordinates: [3.05, 36.7539] },
    "AND": { name: "Andorra", coordinates: [1.5218, 42.5063] },
    "AGO": { name: "Angola", coordinates: [13.2343, -8.8315] },
    "ATG": { name: "Antigua and Barbuda", coordinates: [-61.8456, 17.1175] },
    "ARG": { name: "Argentina", coordinates: [-58.3816, -34.6037] },
    "ARM": { name: "Armenia", coordinates: [44.5086, 40.1872] },
    "AUS": { name: "Australia", coordinates: [149.13, -35.2809] },
    "AUT": { name: "Austria", coordinates: [16.3738, 48.2082] },
    "AZE": { name: "Azerbaijan", coordinates: [49.8671, 40.4093] },
    "BHS": { name: "Bahamas", coordinates: [-77.339, 25.0343] },
    "BHR": { name: "Bahrain", coordinates: [50.5822, 26.2154] },
    "BGD": { name: "Bangladesh", coordinates: [90.4125, 23.8103] },
    "BRB": { name: "Barbados", coordinates: [-59.5432, 13.1939] },
    "BLR": { name: "Belarus", coordinates: [27.5539, 53.9045] },
    "BEL": { name: "Belgium", coordinates: [4.3517, 50.8503] },
    "BLZ": { name: "Belize", coordinates: [-88.7691, 17.2534] },
    "BEN": { name: "Benin", coordinates: [2.3158, 6.4779] },
    "BTN": { name: "Bhutan", coordinates: [89.6439, 27.5142] },
    "BOL": { name: "Bolivia", coordinates: [-68.1193, -16.4897] },
    "BIH": { name: "Bosnia and Herzegovina", coordinates: [18.4131, 43.8563] },
    "BWA": { name: "Botswana", coordinates: [25.9201, -24.6282] },
    "BRA": { name: "Brazil", coordinates: [-47.9297, -15.7801] },
    "BRN": { name: "Brunei", coordinates: [114.9369, 4.9031] },
    "BGR": { name: "Bulgaria", coordinates: [23.3217, 42.6977] },
    "BFA": { name: "Burkina Faso", coordinates: [-1.5197, 12.3714] },
    "BDI": { name: "Burundi", coordinates: [29.3639, -3.3784] },
    "KHM": { name: "Cambodia", coordinates: [104.8922, 11.5449] },
    "CMR": { name: "Cameroon", coordinates: [11.5174, 3.848] },
    "CAN": { name: "Canada", coordinates: [-75.6972, 45.4215] },
    "CPV": { name: "Cape Verde", coordinates: [-23.5133, 14.9218] },
    "CAF": { name: "Central African Republic", coordinates: [18.5581, 4.3947] },
    "TCD": { name: "Chad", coordinates: [15.0444, 12.1067] },
    "CHL": { name: "Chile", coordinates: [-70.6693, -33.4489] },
    "CHN": { name: "China", coordinates: [116.4074, 39.9042] },
    "COL": { name: "Colombia", coordinates: [-74.0721, 4.711] },
    "COM": { name: "Comoros", coordinates: [43.3333, -11.6455] },
    "COG": { name: "Congo", coordinates: [15.2832, -4.2634] },
    "COD": { name: "Congo, Democratic Republic", coordinates: [15.2663, -4.4419] },
    "CRI": { name: "Costa Rica", coordinates: [-84.0788, 9.9281] },
    "CIV": { name: "Cote d'Ivoire", coordinates: [-4.0305, 5.345] },
    "HRV": { name: "Croatia", coordinates: [15.9779, 45.8144] },
    "CUB": { name: "Cuba", coordinates: [-82.3666, 23.1136] },
    "CYP": { name: "Cyprus", coordinates: [33.3823, 35.1856] },
    "CZE": { name: "Czech Republic", coordinates: [14.4205, 50.0884] },
    "DNK": { name: "Denmark", coordinates: [12.5683, 55.6761] },
    "DJI": { name: "Djibouti", coordinates: [43.1425, 11.5806] },
    "DMA": { name: "Dominica", coordinates: [-61.3853, 15.3091] },
    "DOM": { name: "Dominican Republic", coordinates: [-69.9312, 18.4861] },
    "ECU": { name: "Ecuador", coordinates: [-78.4678, -0.1807] },
    "EGY": { name: "Egypt", coordinates: [31.2357, 30.0444] },
    "SLV": { name: "El Salvador", coordinates: [-89.2182, 13.6929] },
    "GNQ": { name: "Equatorial Guinea", coordinates: [8.7741, 3.7523] },
    "ERI": { name: "Eritrea", coordinates: [38.9183, 15.3315] },
    "EST": { name: "Estonia", coordinates: [24.7536, 59.437] },
    "ETH": { name: "Ethiopia", coordinates: [38.7468, 8.9806] },
    "FJI": { name: "Fiji", coordinates: [178.4419, -18.1416] },
    "FIN": { name: "Finland", coordinates: [24.9384, 60.1699] },
    "FRA": { name: "France", coordinates: [2.3522, 48.8566] },
    "GAB": { name: "Gabon", coordinates: [9.4672, 0.4162] },
    "GMB": { name: "Gambia", coordinates: [-16.5885, 13.4549] },
    "GEO": { name: "Georgia", coordinates: [44.7837, 41.7151] },
    "DEU": { name: "Germany", coordinates: [13.4115, 52.5235] },
    "GHA": { name: "Ghana", coordinates: [-0.1869, 5.6037] },
    "GRC": { name: "Greece", coordinates: [23.7275, 37.9838] },
    "GRD": { name: "Grenada", coordinates: [-61.7603, 12.1165] },
    "GTM": { name: "Guatemala", coordinates: [-90.5069, 14.6349] },
    "GIN": { name: "Guinea", coordinates: [-13.7065, 9.5092] },
    "GNB": { name: "Guinea-Bissau", coordinates: [-15.1804, 11.8636] },
    "GUY": { name: "Guyana", coordinates: [-58.1548, 6.8013] },
    "HTI": { name: "Haiti", coordinates: [-72.3288, 18.5944] },
    "HND": { name: "Honduras", coordinates: [-87.2068, 14.0723] },
    "HUN": { name: "Hungary", coordinates: [19.0399, 47.4984] },
    "ISL": { name: "Iceland", coordinates: [-21.9426, 64.1466] },
    "IND": { name: "India", coordinates: [77.2088, 28.6139] },
    "IDN": { name: "Indonesia", coordinates: [106.8456, -6.2088] },
    "IRN": { name: "Iran", coordinates: [51.4, 35.7] },
    "IRQ": { name: "Iraq", coordinates: [44.4, 33.3] },
    "IRL": { name: "Ireland", coordinates: [-6.2675, 53.3441] },
    "ISR": { name: "Israel", coordinates: [35.2137, 31.769] },
    "ITA": { name: "Italy", coordinates: [12.4964, 41.9028] },
    "JAM": { name: "Jamaica", coordinates: [-76.8, 18.0] },
    "JPN": { name: "Japan", coordinates: [139.6917, 35.6895] },
    "JOR": { name: "Jordan", coordinates: [35.9263, 31.9454] },
    "KAZ": { name: "Kazakhstan", coordinates: [71.4704, 51.1605] },
    "KEN": { name: "Kenya", coordinates: [36.8126, -1.286] },
    "KIR": { name: "Kiribati", coordinates: [169.5347, 1.3382] },
    "PRK": { name: "North Korea", coordinates: [125.7625, 39.0392] },
    "KOR": { name: "South Korea", coordinates: [126.978, 37.5665] },
    "KWT": { name: "Kuwait", coordinates: [47.9824, 29.3759] },
    "KGZ": { name: "Kyrgyzstan", coordinates: [74.5698, 42.8746] },
    "LAO": { name: "Laos", coordinates: [102.6, 17.9667] },
    "LVA": { name: "Latvia", coordinates: [24.1052, 56.9465] },
    "LBN": { name: "Lebanon", coordinates: [35.5018, 33.8938] },
    "LSO": { name: "Lesotho", coordinates: [27.4833, -29.3167] },
    "LBR": { name: "Liberia", coordinates: [-10.7957, 6.3004] },
    "LBY": { name: "Libya", coordinates: [13.1913, 32.8872] },
    "LIE": { name: "Liechtenstein", coordinates: [9.5215, 47.1417] },
    "LTU": { name: "Lithuania", coordinates: [25.2797, 54.6872] },
    "LUX": { name: "Luxembourg", coordinates: [6.1296, 49.6116] },
    "MKD": { name: "North Macedonia", coordinates: [21.4254, 41.9981] },
    "MDG": { name: "Madagascar", coordinates: [45.7, -18.7669] },
    "MWI": { name: "Malawi", coordinates: [33.7703, -13.9626] },
    "MYS": { name: "Malaysia", coordinates: [101.6953, 3.139] },
    "MDV": { name: "Maldives", coordinates: [73.5093, 4.1755] },
    "MLI": { name: "Mali", coordinates: [-8.0, 12.65] },
    "MLT": { name: "Malta", coordinates: [14.5, 35.9] },
    "MHL": { name: "Marshall Islands", coordinates: [171.3842, 7.1315] },
    "MRT": { name: "Mauritania", coordinates: [-15.9785, 18.0735] },
    "MUS": { name: "Mauritius", coordinates: [57.5522, -20.3484] },
    "MEX": { name: "Mexico", coordinates: [-99.1332, 19.4326] },
    "FSM": { name: "Micronesia", coordinates: [158.2, 6.9236] },
    "MDA": { name: "Moldova", coordinates: [28.8575, 47.0105] },
    "MCO": { name: "Monaco", coordinates: [7.4246, 43.7384] },
    "MNG": { name: "Mongolia", coordinates: [106.9057, 47.8864] },
    "MNE": { name: "Montenegro", coordinates: [19.2594, 42.4304] },
    "MAR": { name: "Morocco", coordinates: [-6.8498, 33.9716] },
    "MOZ": { name: "Mozambique", coordinates: [32.5822, -25.9692] },
    "MMR": { name: "Myanmar", coordinates: [96.1951, 16.8661] },
    "NAM": { name: "Namibia", coordinates: [17.0658, -22.5609] },
    "NRU": { name: "Nauru", coordinates: [166.9211, -0.5228] },
    "NPL": { name: "Nepal", coordinates: [85.3, 27.7] },
    "NLD": { name: "Netherlands", coordinates: [4.9041, 52.3676] },
    "NZL": { name: "New Zealand", coordinates: [174.7787, -41.2924] },
    "NIC": { name: "Nicaragua", coordinates: [-86.2504, 12.1328] },
    "NER": { name: "Niger", coordinates: [2.1073, 13.5117] },
    "NGA": { name: "Nigeria", coordinates: [7.3986, 9.0765] },
    "NOR": { name: "Norway", coordinates: [10.7522, 59.9139] },
    "OMN": { name: "Oman", coordinates: [58.4, 23.6] },
    "PAK": { name: "Pakistan", coordinates: [73.0, 33.7] },
    "PLW": { name: "Palau", coordinates: [134.4735, 7.5022] },
    "PAN": { name: "Panama", coordinates: [-79.5188, 8.9936] },
    "PNG": { name: "Papua New Guinea", coordinates: [147.194, -9.4438] },
    "PRY": { name: "Paraguay", coordinates: [-57.6309, -25.2637] },
    "PER": { name: "Peru", coordinates: [-77.0428, -12.0464] },
    "PHL": { name: "Philippines", coordinates: [120.9842, 14.5995] },
    "POL": { name: "Poland", coordinates: [21.0122, 52.2297] },
    "PRT": { name: "Portugal", coordinates: [-9.1427, 38.7223] },
    "QAT": { name: "Qatar", coordinates: [51.5, 25.3] },
    "ROU": { name: "Romania", coordinates: [26.1025, 44.4268] },
    "RUS": { name: "Russia", coordinates: [37.6173, 55.7558] },
    "RWA": { name: "Rwanda", coordinates: [30.0619, -1.9403] },
    "KNA": { name: "Saint Kitts and Nevis", coordinates: [-62.7309, 17.3578] },
    "LCA": { name: "Saint Lucia", coordinates: [-60.9896, 14.0101] },
    "VCT": { name: "Saint Vincent and the Grenadines", coordinates: [-61.2872, 13.2528] },
    "WSM": { name: "Samoa", coordinates: [-171.777, -13.8314] },
    "SMR": { name: "San Marino", coordinates: [12.4578, 43.9424] },
    "STP": { name: "Sao Tome and Principe", coordinates: [6.7273, 0.3302] },
    "SAU": { name: "Saudi Arabia", coordinates: [46.675, 24.7136] },
    "SEN": { name: "Senegal", coordinates: [-17.4734, 14.7167] },
    "SRB": { name: "Serbia", coordinates: [20.4892, 44.804] },
    "SYC": { name: "Seychelles", coordinates: [55.4466, -4.6796] },
    "SLE": { name: "Sierra Leone", coordinates: [-13.2317, 8.4606] },
    "SGP": { name: "Singapore", coordinates: [103.8198, 1.357] },
    "SVK": { name: "Slovakia", coordinates: [17.1077, 48.1486] },
    "SVN": { name: "Slovenia", coordinates: [14.5058, 46.0569] },
    "SLB": { name: "Solomon Islands", coordinates: [159.9498, -9.4456] },
    "SOM": { name: "Somalia", coordinates: [45.3254, 2.0469] },
    "ZAF": { name: "South Africa", coordinates: [28.1871, -25.7461] },
    "SSD": { name: "South Sudan", coordinates: [31.6, 4.85] },
    "ESP": { name: "Spain", coordinates: [-3.7038, 40.4168] },
    "LKA": { name: "Sri Lanka", coordinates: [79.8612, 6.9271] },
    "SDN": { name: "Sudan", coordinates: [32.5363, 15.5932] },
    "SUR": { name: "Suriname", coordinates: [-55.2038, 5.852] },
    "SWE": { name: "Sweden", coordinates: [18.0686, 59.3293] },
    "CHE": { name: "Switzerland", coordinates: [7.4474, 46.9480] },
    "SYR": { name: "Syria", coordinates: [36.3, 33.5] },
    "TWN": { name: "Taiwan", coordinates: [121.5654, 25.033] },
    "TJK": { name: "Tajikistan", coordinates: [68.7739, 38.5737] },
    "TZA": { name: "Tanzania", coordinates: [39.2695, -6.8235] },
    "THA": { name: "Thailand", coordinates: [100.5018, 13.7563] },
    "TLS": { name: "Timor-Leste", coordinates: [125.5766, -8.5586] },
    "TGO": { name: "Togo", coordinates: [1.2255, 6.1375] },
    "TON": { name: "Tonga", coordinates: [-175.2, -21.1333] },
    "TTO": { name: "Trinidad and Tobago", coordinates: [-61.5166, 10.6667] },
    "TUN": { name: "Tunisia", coordinates: [10.1733, 36.8065] },
    "TUR": { name: "Turkey", coordinates: [32.8597, 39.9334] },
    "TKM": { name: "Turkmenistan", coordinates: [58.3833, 37.95] },
    "TUV": { name: "Tuvalu", coordinates: [179.1995, -8.5167] },
    "UGA": { name: "Uganda", coordinates: [32.5811, 0.3136] },
    "UKR": { name: "Ukraine", coordinates: [30.5234, 50.4501] },
    "ARE": { name: "United Arab Emirates", coordinates: [54.3705, 24.4764] },
    "GBR": { name: "United Kingdom", coordinates: [-0.1278, 51.5074] },
    "USA": { name: "United States", coordinates: [-77.0369, 38.9072] },
    "URY": { name: "Uruguay", coordinates: [-56.1645, -34.9011] },
    "UZB": { name: "Uzbekistan", coordinates: [69.2401, 41.2995] },
    "VUT": { name: "Vanuatu", coordinates: [168.327, -17.7365] },
    "VAT": { name: "Vatican City", coordinates: [12.4534, 41.9029] },
    "VEN": { name: "Venezuela", coordinates: [-66.9036, 10.4806] },
    "VNM": { name: "Vietnam", coordinates: [105.8542, 21.0285] },
    "YEM": { name: "Yemen", coordinates: [44.2, 15.3694] },
    "ZMB": { name: "Zambia", coordinates: [28.2833, -15.4167] },
    "ZWE": { name: "Zimbabwe", coordinates: [31.0672, -17.8312] }
  };
export default COUNTRY_CODES;